/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mentorexchangemethod2Inputs */

const en__field_mentorexchangemethod2 = /** @type {(inputs: _Field_Mentorexchangemethod2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where should your meeting take place`)
};

const de__field_mentorexchangemethod2 = /** @type {(inputs: _Field_Mentorexchangemethod2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie soll der Austausch stattfinden?`)
};

/**
* | output |
* | --- |
* | "Where should your meeting take place" |
*
* @param {_Field_Mentorexchangemethod2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_mentorexchangemethod2 = /** @type {((inputs?: _Field_Mentorexchangemethod2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mentorexchangemethod2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentorexchangemethod2(inputs)
	return de__field_mentorexchangemethod2(inputs)
});
export { _field_mentorexchangemethod2 as "_field_mentorExchangeMethod" }